export const getRoutedUrl = (url: string) => {
    // eslint-disable-next-line no-restricted-properties -- allowed here
    if (url.startsWith(document.location.origin)) return url.substring(document.location.origin.length)
    return url
}
